module.exports = "/_next/static/images/eshopRychle-773c110a3e27c73c886d799ecea81624.png";